/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-20 09:41:19 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 14:05:32
 */

<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Seller FAQ"/>
    <div class="docs">
      <h1>Activate Product(s)</h1>
      <h2>1. How do I activate products on Artemis Ads?</h2>
      <p>You can activate products in three ways:</p>
      <ul>
        <li>
          Activate individual products: Click the “Activate” button next to each
          product.
        </li>
        <li>
          Activate multiple products: Select all products(up to 100) on the
          current page and choose “Actions – Activate All.”
        </li>
        <li>
          Bulk activate via CSV: Upload a CSV file to update product statuses to
          “Active” or “Inactive” in bulk.
        </li>
      </ul>
      <h2>2. Can I update commission rates for individual products?</h2>
      <p>Yes!</p>
      <p>
        After activating your products, you can configure individual commission
        rates as needed. Simply navigate to the product settings and adjust the
        rates. And the new commission rates will take effect the next day.
      </p>
      <h2>3. How do I bulk update product statuses?</h2>
      <p>To bulk update product statuses:</p>
      <ul>
        <li>
          Prepare a CSV file with your product data. It’s recommended to
          download the template and edit, and keep the same format.
        </li>
        <li>Upload the file to Artemis Ads.</li>
        <li>Choose “Active” or “Inactive” for the products in the file.</li>
        <li>This is a quick way to manage large numbers of products.</li>
      </ul>
      <h2>4. What happens after I activate my products?</h2>
      <p>
        Once activated, your products will be visible to publishers, so that
        they can start to promote your brands and products. Make sure your
        commission rates are set to attract the best opportunities.
      </p>
      <h2>5. Can I deactivate products later?</h2>
      <p>
        Yes, you can deactivate products at any time by changing their status to
        “Inactive” individually or in bulk via CSV upload.
      </p>
      <h2>6. Quick Tips for Product Activation</h2>
      <ul>
        <li>
          Activate all relevant products: Ensure all your products are activated
          to maximize your campaign reach, even though the products may be
          currently out of stock.
        </li>
        <li>
          Set competitive commission rates: Adjust rates to maximize earnings
          while staying competitive.
        </li>
        <li>
          Use bulk actions for efficiency: Save time by activating or
          deactivating multiple products at once.
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>